<template>
<div class="chapter">
<div class="inner_page">
<div class="group">
<p class="C593"><span class="size_145"><span class="color_0B0E11"><strong><span id="id_3">Space</span></strong></span></span></p>
<p class="C580">Empty space is beautiful. It adds an element of calm and elegance to your design. It gives your eye a place to rest. Space, in design terms, is often called negative space or white space. But it doesn’t have to be white. Adding space to a quilt design gives the various elements of the quilt a chance to be seen and appreciated—otherwise the design is just too noisy. By controlling space, you are able to create rhythm and relationships.</p>
</div>
<div class="group">
<p class="C580"><em>Seedpod</em> uses “windows,” which give the quilt space to breathe.</p>
<p class="C572"><img alt="" src="img/14_1.jpg"/></p>
<p class="C694"><span class="size_85">Seedpod (<span href="#/xhtml/32_Seedpod_#page_106" title="Link target outside of Sample">page 106</span>), detail</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Space.vue?6076a04a